import { useState } from "react";
import { InputSwitch } from "primereact/inputswitch";

import GraficoPrevisao from "./GraficoPrevisao";
import TabelaPrevisao from "../../Tabelas/TabelaPrevisao";

const methodLabels = {
  seasonal: "Tendência sazonal",
  winters: "Holt-Winters",
};

const Comparativo = ({ series, futureLabels, forecasts, available }) => {
  const [showValues, setShowValues] = useState(false); // escondido por padrão
  const methods = Object.entries(forecasts).map(([key, method]) =>
    method ? { key, method } : null);

  return (
  <>
    {available ? (
        <>
          <div className="p-d-flex p-ai-center p-mb-3" style={{ gap: 8 }}>
            <InputSwitch
              inputId="show-values"
              checked={showValues}
              onChange={(event) => setShowValues(event.value)}
            />
            <label htmlFor="show-values">Exibir valores no gráfico</label>
          </div>
      <GraficoPrevisao
        series={series}
        futureLabels={futureLabels}
            showValues={showValues}
            methods={methods}
      />
        </>
    ) : null}
    <table className="p-datatable-table p-mt-4" style={{ width: "100%" }}>
      <thead><tr><th>Método</th><th>Erro MAPE</th><th>Disponibilidade</th></tr></thead>
      <tbody>
        {Object.entries(forecasts).map(([key, method]) => (
          <tr key={key}>
            <td>{method?.label || methodLabels[key]}</td>
            <td>{!available || method?.mape === null || !method ? "—" : `${method.mape.toFixed(1)}%`}</td>
            <td>{!available ? "Exige 6 meses" : method ? "Disponível" : "Exige 24 meses"}</td>
          </tr>
        ))}
      </tbody>
    </table>
      <TabelaPrevisao series={series} futureLabels={futureLabels} methods={methods} />
  </>
);
};

export default Comparativo;